import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';

const YOAST_SNIPPET = `add_action('rest_api_init', function() {
    register_meta('post', '_yoast_wpseo_focuskw', array(
        'show_in_rest' => true,
        'single' => true,
        'type' => 'string',
        'auth_callback' => function() { return current_user_can('edit_posts'); }
    ));
    register_meta('post', '_yoast_wpseo_metadesc', array(
        'show_in_rest' => true,
        'single' => true,
        'type' => 'string',
        'auth_callback' => function() { return current_user_can('edit_posts'); }
    ));
    register_meta('post', '_yoast_wpseo_title', array(
        'show_in_rest' => true,
        'single' => true,
        'type' => 'string',
        'auth_callback' => function() { return current_user_can('edit_posts'); }
    ));
});`;

const RANKMATH_SNIPPET = `add_action('rest_api_init', function() {
    register_meta('post', 'rank_math_focus_keyword', array(
        'show_in_rest' => true,
        'single' => true,
        'type' => 'string',
        'auth_callback' => function() { return current_user_can('edit_posts'); }
    ));
    register_meta('post', 'rank_math_description', array(
        'show_in_rest' => true,
        'single' => true,
        'type' => 'string',
        'auth_callback' => function() { return current_user_can('edit_posts'); }
    ));
    register_meta('post', 'rank_math_title', array(
        'show_in_rest' => true,
        'single' => true,
        'type' => 'string',
        'auth_callback' => function() { return current_user_can('edit_posts'); }
    ));
});`;

export function SeoSnippetHelper({ plugin }: { plugin: 'yoast' | 'rankmath' }) {
  const [copied, setCopied] = useState(false);
  const snippet = plugin === 'yoast' ? YOAST_SNIPPET : RANKMATH_SNIPPET;
  const name = plugin === 'yoast' ? 'Yoast SEO' : 'Rank Math SEO';

  const onCopy = async () => {
    await navigator.clipboard.writeText(snippet);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-start justify-between gap-2">
        <div className="text-sm">
          <p className="font-medium text-foreground">{name} için functions.php kodu</p>
          <p className="text-xs text-muted-foreground mt-0.5">
            Makale meta alanlarının REST API'den yazılabilmesi için aktif temanın{' '}
            <code className="px-1 py-0.5 bg-muted rounded text-[11px]">functions.php</code> dosyasının sonuna
            bu kodu ekle.
          </p>
        </div>
        <Button size="sm" variant="outline" type="button" onClick={onCopy}>
          {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
          {copied ? 'Kopyalandı' : 'Kopyala'}
        </Button>
      </div>
      <pre className="text-[11px] font-mono bg-muted rounded-md p-3 overflow-x-auto max-h-48 leading-relaxed">
        {snippet}
      </pre>
    </div>
  );
}
